import React, { useEffect, useState } from 'react';
import FranchiseListing from './FranchiseListing';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { setIsOpenAddDialog, setIsOpenEditDialog, setPage, setRowsPerPage, setSearchValue, setIsTableLoading, setItems, setTotalItems } from 'src/redux/slices/FranchiseSlice';
import AddFranchiseWrapper from '../Add/AddFranchiseWrapper';
import ATMMenu from 'src/components/UI/atoms/ATMMenu/ATMMenu';
import { showConfirmationDialog } from 'src/utils/showConfirmationDialog';
import { showToast } from 'src/utils/showToaster';
import EditFranchiseFormWrapper from '../Edit/EditFranchiseFormWrapper';
import { useChangeStatusFranchiseByIdMutation, useDeleteFranchiseByIdMutation, useGetAllFranchiseDataQuery, useGetAllFranchiseExcelDataMutation } from 'src/services/FranchiseService';
import ListDateTime from 'src/components/UI/atoms/ListDateTime/ListDateTime';
import moment from 'moment';
import { Tooltip } from '@mui/material';
import { usePermission } from 'src/hooks/usePermission';

type Props = {};

const FranchiseListingWrapper = (props: Props) => {
  const dispatch = useDispatch();

  const { items, totalItems, page, isOpenAddDialog, rowsPerPage, isOpenEditDialog, searchValue, isTableLoading, dateFilter } =
    useSelector((state: RootState) => state.franchise);
  const [deleteFranchise] = useDeleteFranchiseByIdMutation()
  const [changeStatusFranchise] = useChangeStatusFranchiseByIdMutation()
  const [selectedFranchiseId, setSelectedFranchiseId] = useState<string>()
  const { data, isLoading, isFetching } = useGetAllFranchiseDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: [
      "name",
      "mobile",
      "location"
    ],
    page: page,
    filterBy: [],
    dateFilter: {
      startDate: dateFilter.start_date
        ? moment(dateFilter?.start_date).format("YYYY-MM-DD")
        : "",
      endDate: dateFilter.end_date
        ? moment(dateFilter?.end_date).format("YYYY-MM-DD")
        : dateFilter.start_date ? moment().format("YYYY-MM-DD") : ''
    },
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);
 const moduleName = "FRANCHISE";

const canEdit = usePermission(moduleName, "UPDATE");
const canDelete = usePermission(moduleName, "DELETE");
const canActive = usePermission(moduleName, "ACTIVE/DEACTIVE");

const getActionOptions = (row: any) => {
  const options = [];

  if (canEdit) {
    options.push({
      label: "Edit",
      onClick: () => {
        dispatch(setIsOpenEditDialog(true));
        setSelectedFranchiseId(row?._id);
      },
    });
  }

  if (canActive) {
    options.push({
      label: row?.isActive ? "Deactive" : "Active",
      onClick: () => {
        const actionLabel = row?.isActive ? "deactive" : "active";
        showConfirmationDialog({
          title: "Heads Up",
          text: `Are you sure want to ${actionLabel} this Franchise?`,
          icon: "question",
          showCancelButton: true,
          next: (result) => {
            if (result.isConfirmed) {
              changeStatusFranchise({ id: row?._id }).then((res: any) => {
                if (res?.error) {
                  showToast("error", res?.error?.data?.message);
                } else {
                  if (res?.data?.status) {
                    showToast("success", "Status changed successfully");
                  } else {
                    showToast("error", res?.data?.message);
                  }
                }
              });
            }
          },
        });
      },
    });
  }

  if (canDelete) {
    options.push({
      label: "Delete",
      onClick: () => {
        showConfirmationDialog({
          title: "Heads Up",
          text: "Are you sure want to delete this Franchise?",
          icon: "question",
          showCancelButton: true,
          next: (result) => {
            if (result.isConfirmed) {
              deleteFranchise(row?._id).then((res: any) => {
                if (res?.error) {
                  showToast("error", res?.error?.data?.message);
                } else {
                  if (res?.data?.status) {
                    showToast("success", "Deleted successfully");
                  } else {
                    showToast("error", res?.data?.message);
                  }
                }
              });
            }
          },
        });
      },
    });
  }

  return options;
};



  const columns: columnTypes[] = [
    {
      field: "date",
      headerName: "Date",
      flex: "flex-[1_1_0%]",
      extraClasses: "min-w-[150px] py-1",
      renderCell: (row: any) => <ListDateTime value={row.createdAt} />,
    },
    {
      field: "name",
      headerName: "Name",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => (
        <Tooltip title={row?.name || "-"}>
          <div className="capitalize"> {row?.name || "-"} </div>
        </Tooltip>
      ),
    },
    {
      field: 'mobile',
      headerName: 'Mobile Number',
      flex: 'flex-[1_1_0%]'
    },
    {
      field: 'location',
      headerName: 'Location',
      flex: 'flex-[1_1_0%]',
       renderCell: (row: any) => (
        <Tooltip title={row?.location || "-"}>
          <div className="capitalize text-left font-normal"> {row?.location || "-"} </div>
        </Tooltip>
      ),
    },
    {
      field: "action",
      headerName: "Actions",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => {
        const options = getActionOptions(row);
        return <ATMMenu options={options} orientation="vertical" />;
      },
    },
  ];

  const [getFranchiseExcel, getFranchiseExcelInfo] = useGetAllFranchiseExcelDataMutation();
  // useEffect(() => {
  //   if (!getFranchiseExcelInfo?.isLoading) {
  //     setfranchiseExcel(getFranchiseExcelInfo?.data?.data || []);
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getFranchiseExcelInfo?.isLoading]);


  return (
    <>
      <div>
        <FranchiseListing
        // setfranchiseExcel={setfranchiseExcel}
        //   franchiseExceldata={franchiseExceldata}
          isloadingExcel={getFranchiseExcelInfo.isLoading}
          getFranchiseExcel={getFranchiseExcel}
          columns={columns}
          rows={items}
          paginationProps={{
            isTableLoading,
            totalItems,
            page,
            rowsPerPage,
            searchValue,
            setPage: (newPage) => dispatch(setPage(newPage)),
            setIsOpenAddDialog: (value) => dispatch(setIsOpenAddDialog(value)),
            setRowsPerPage: (newRowsPerPage) => dispatch(setRowsPerPage(newRowsPerPage)),
            setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
          }}
        />
      </div>
      {isOpenAddDialog ? (
        <AddFranchiseWrapper
          onClose={() => dispatch(setIsOpenAddDialog(false))}
        />
      ) : null}
      {isOpenEditDialog ? (
        <EditFranchiseFormWrapper
          onClose={() => dispatch(setIsOpenEditDialog(false))}
          selectedFranchiseId={selectedFranchiseId || ""}
        />
      ) : null}
    </>
  );
};

export default FranchiseListingWrapper;